import React, { useEffect, useState } from "react";

function LiveHero({ liveMatch, liveScore }) {
    const [time, setTime] = useState("");

    useEffect(() => {
        const updateClock = () => {
            const now = new Date();
            setTime(now.toTimeString().slice(0, 8));
        };
        updateClock();
        const interval = setInterval(updateClock, 1000);
        return () => clearInterval(interval);
    }, []);

    const getTeamName = (index) => {
        if (!liveMatch) return "TBD";
        if (index === 0) return liveMatch.team1Name || "TBD";
        return liveMatch.team2Name || "TBD";
    };

    const getTeamLogo = (index) => {
        if (!liveMatch) return null;
        if (index === 0) return liveMatch.team1PicURL || null;
        return liveMatch.team2PicURL || null;
    };

    // Get innings data
    const innings1 = liveScore?.matchInningList?.[0] || null;
    const innings2 = liveScore?.matchInningList?.[1] || null;
    const currentInnings = innings2 || innings1;
    const inningsLabel = innings2 ? "2ND INNINGS" : "1ST INNINGS";


    if (!liveMatch) {
        return (
            <div className="hero" id="live-hero">
                <div className="hero-stadium"></div>
                <div className="hero-inner">
                    <div style={{ textAlign: "center", padding: "40px 0", color: "var(--text2)" }}>
                        No live match right now
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="hero" id="live-hero">
            <div className="hero-stadium"></div>
            <div className="hero-inner">
                <div className="hero-top-row">
                    <div className="match-badge-row">
                        <div className="live-badge">
                            <span className="ping-dot" style={{ background: "var(--pink)" }}></span>LIVE
                        </div>
                        <div className="over-badge">{liveMatch.overs} OVER FORMAT</div>
                        <div className="match-id-badge">VIRTUAL IPL · MATCH #{liveMatch.matchId}</div>
                    </div>
                    <div className="hero-clock">{time}</div>
                </div>

                <div className="scoreboard">
                    <div className="team-side">
                        <div className="team-logo batting">
                            {getTeamLogo(0) ? (
                                <img src={getTeamLogo(0)} alt={getTeamName(0)}
                                     onError={(e) => { e.target.style.display = 'none'; }} />
                            ) : "🏏"}
                        </div>
                        <div className="team-name">{getTeamName(0)}</div>
                        <div className="team-name-sub">(e)</div>
                        <div className="team-score-big">
                            {innings1 ? innings1.runs : "0"}
                            <span className="wkts">/{innings1 ? innings1.wickets : "0"}</span>
                        </div>
                        <div className="team-overs-txt">
                            {innings1 ? `${innings1.numberOfOvers} OVERS` : "0 OVERS"}
                        </div>
                    </div>

                    <div className="vs-center">
                        <span className="vs-txt">VS</span>
                        <span className="inn-label">{inningsLabel}</span>
                        <div className="sim-indicator">
                            <div className="sim-dot"></div>AI MATCH
                        </div>
                    </div>

                    <div className="team-side right">
                        <div className="team-logo">
                            {getTeamLogo(1) ? (
                                <img src={getTeamLogo(1)} alt={getTeamName(1)}
                                     onError={(e) => { e.target.style.display = 'none'; }} />
                            ) : "🏏"}
                        </div>
                        <div className="team-name">{getTeamName(1)}</div>
                        <div className="team-name-sub">(e)</div>
                        {innings2 ? (
                            <>
                                <div className="team-score-big">
                                    {innings2.runs}
                                    <span className="wkts">/{innings2.wickets}</span>
                                </div>
                                <div className="team-overs-txt">{innings2.numberOfOvers} OVERS</div>
                            </>
                        ) : (
                            <>
                                <div className="team-score-big tbd">— —</div>
                                <div className="team-overs-txt">YET TO BAT</div>
                            </>
                        )}
                    </div>
                </div>

                {liveScore?.matchOverSummaryDtoList && liveScore.matchOverSummaryDtoList.length > 0 && (
                    <div className="ball-row">
                        {liveScore.matchOverSummaryDtoList.slice(-6).map((ball, i) => {
                            const outcome = ball.actionOutCome;
                            let cls = "ball";
                            let label = "·";
                            if (outcome === "FOUR_RUNS") { cls += " four"; label = "4"; }
                            else if (outcome === "SIX_RUNS") { cls += " six"; label = "6"; }
                            else if (outcome === "OUT") { cls += " wicket"; label = "W"; }
                            else if (outcome === "NO_RUNS" || outcome === "WIDE") { cls += " dot"; label = "·"; }
                            else if (outcome === "ONE_RUN") { cls += " run1"; label = "1"; }
                            else if (outcome === "TWO_RUNS") { cls += " run2"; label = "2"; }
                            else if (outcome === "THREE_RUNS") { cls += " run1"; label = "3"; }
                            else { cls += " run1"; label = "?"; }
                            return <div key={i} className={cls}>{label}</div>;
                        })}
                    </div>
                )}

                <div className="match-players">
                    <div className="mp-card">
                        <div className="mp-role">Batter (e)</div>
                        <div className="mp-name">
                            {currentInnings?.currentBattingPlayer?.name || "—"}
                        </div>
                        <div className="mp-stats">
                            <span className="mp-stat-hi">
                                {currentInnings?.playerBattingProfileList?.[0] ?
                                    `${currentInnings.playerBattingProfileList[0].runs}* (${currentInnings.playerBattingProfileList[0].bowls})` : "—"}
                            </span>
                        </div>
                    </div>
                    <div className="mp-card">
                        <div className="mp-role">Bowler (e)</div>
                        <div className="mp-name">
                            {currentInnings?.lastBowlingPlayer?.name || "—"}
                        </div>
                        <div className="mp-stats">
                            <span className="mp-stat-hi">
                                {currentInnings?.playerBowlingProfileList?.[0] ?
                                    `${currentInnings.playerBowlingProfileList[0].wickets}/${currentInnings.playerBowlingProfileList[0].runs}` : "—"}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default LiveHero;
